import React, { useEffect, useState } from 'react';

function DictListEditor({ data, onChange }) {
  const [dictList, setDictList] = useState(data);

  const handleKeyChange = (index, event) => {
    const newDictList = [...dictList];
    newDictList[index].key = event.target.value;
    setDictList(newDictList);
    onChange(newDictList);
  };

  const handleValueChange = (index, event) => {
    const newDictList = [...dictList];
    newDictList[index].value = event.target.value;
    setDictList(newDictList);
    onChange(newDictList);
  };

  const handleAddDict = () => {
    const newDictList = [...dictList, { key: '', value: '' }];
    setDictList(newDictList);
    onChange(newDictList);
  };

  const handleRemoveDict = (index) => {
    const newDictList = [...dictList];
    newDictList.splice(index, 1);
    setDictList(newDictList);
    onChange(newDictList);
  };

  useEffect(() => {
    setDictList(data);
  }, [data]);

  return (
    <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        width: '100%',
    }}>
      {dictList.map((dict, index) => (
        <div key={index} style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
            width: '100%',
        }}>
          <input type="text" value={dict.key} placeholder='항목명' onChange={(event) => handleKeyChange(index, event)} />
          <input type="text" value={dict.value} placeholder='항목내용(문자열)' onChange={(event) => handleValueChange(index, event)} />
          <button onClick={() => handleRemoveDict(index)}>Remove</button>
        </div>
      ))}
      <button onClick={handleAddDict}>Add</button>
    </div>
  );
}

export default DictListEditor;
